<template>
  <div class="cxm-ProgressLabelItem">
    <div :style="dotColor" />
    <Typography is="span">
      {{ label }}
    </Typography>
  </div>
</template>

<script>
import Typography from '@/packages/ui/components/Typography/Typography.vue';

export default {
  name: 'ProgressLabelItem',
  components: {
    Typography,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  },
  computed: {
    dotColor() {
      return { backgroundColor: `var(${this.color})` };
    },
  },
};

</script>

<style scoped lang="scss" >
 .cxm-ProgressLabelItem {
    display: flex;
    align-items: center;
    gap: var(--track-spacing-sm);

    & > span {
      color: var(--track-color-bluegray-80);
      font-size: var(--track-font-size-xxs);
      font-weight: var(--track-font-weight-medium);
    }

    & > div {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }

  }
</style>
